import * as React from 'react';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SvgContentCopy = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 44,
  height: 44,
  viewBox: "14 13 15 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M25.053 13h-9.474C14.71 13 14 13.736 14 14.636v11.455h1.579V14.636h9.474V13Zm2.368 3.273h-8.684c-.869 0-1.58.736-1.58 1.636v11.455c0 .9.711 1.636 1.58 1.636h8.684C28.29 31 29 30.264 29 29.364V17.909c0-.9-.71-1.636-1.579-1.636Zm0 13.09h-8.684V17.91h8.684v11.455Z",
  fill: "#000",
  style: {
    fill: "currentColor"
  }
}));

export { SvgContentCopy as default };
